export default [
  {
    path: '',
    name: 'main-page',
    component: () => import('@/views/pages/front/MainPage.vue'),
    meta: {
      pageTitle: 'Dashboard',
      breadcrumb: [
        {
          text: 'Dashboard',
          active: true,
        },
      ],
    },
  },
]
